import React from "react"
import styled from "styled-components"
import { rhythm } from "../../utils/typography"

const BlockquoteDiv = styled.blockquote`
  padding: ${rhythm(1)};
  margin: ${rhythm(1)} 0;
  border-left: 2px solid var(--color-primary);
  border-right: 2px solid var(--color-primary);
  color: var(--color-headingFont);
  background: var(--color-foreground);
  border-radius: 0px;
`

const Blockquote = props => {
  return <BlockquoteDiv {...props} />
}

export default Blockquote
